import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSignIn$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSignIn extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'f117999d41437aaebe7f64c3e70887f36f69417e', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '3ffea0a8f78bc4d1a0be903d0f39e57a09fdad3d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '778de442d6538ee1a1606dc5307db58c2658a4c0', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.5 16.5v3a.5.5 0 0 1-.5.5H2.5a.5.5 0 0 1-.5-.5v-17a.5.5 0 0 1 .5-.5H13a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-2H3.5v15H12v-2a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5M9.919 7.284c.165.068.273.23.273.408v2.558H19.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-9.308v2.558a.442.442 0 0 1-.755.312L6.13 11.312a.44.44 0 0 1 0-.625L9.437 7.38a.44.44 0 0 1 .482-.095", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-sign-in", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-sign-in"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-sign-in":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSignIn$1);
            }
            break;
    } });
}

const CosmosIconSignIn = CosmosIconSignIn$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSignIn, defineCustomElement };
